import { createApp } from 'vue'
import App from './App.vue'
import router from "./router";
import VueProgressBar from "@aacassandra/vue3-progressbar";

import AOS from 'aos'
import 'aos/dist/aos.css'
import i18n from './i18n'
import store from "./state/store";

import BootstrapVue3 from 'bootstrap-vue-3';
import vClickOutside from "click-outside-vue3"
import VueApexCharts from "vue3-apexcharts";
import Maska from 'maska';

import VueFeather from 'vue-feather';
import Particles from "particles.vue3";

import '@/assets/scss/config/default/app.scss';
import '@vueform/slider/themes/default.css';


import Notifications from '@kyvg/vue3-notification'

AOS.init({
    easing: 'ease-out-back',
    duration: 1000
})

const options = {
    color: "#bffaf3",
    failedColor: "#874b4b",
    thickness: "2px",
    transition: {
        speed: "0.2s",
        opacity: "0.6s",
        termination: 300,
    },
    autoRevert: true,
    location: "left",
    inverse: false,
};
import "./http/api";

createApp(App)
    .use(VueProgressBar, options)
    .use(store)
    .use(router)
    .use(VueApexCharts)
    .use(BootstrapVue3)
    .component(VueFeather.type, VueFeather)
    .use(Maska)
    .use(Particles)
    .use(i18n)
    .use(Notifications)
    .use(vClickOutside)
    .mount('#app')


